export default {
      id: "kindergartens-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "icons/symbols.67516b0a.svg#kindergartens",
      toString: function () {
        return this.url;
      }
    }